import { render } from "./App.vue?vue&type=template&id=4aa592e2"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4aa592e2&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\Unimagem\\encontreEspecialista\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__